import { FeaturesReady } from '@growthbook/growthbook-react';
import { Modal } from '@material-ui/core';
import React, { PropsWithChildren } from 'react';
import { DSSpinner } from '../../designSystem';

const LoadingSpinner: React.FC = () => {
	return (
		<Modal
			className="overflow-hiddden flex items-center justify-center backdrop-blur-sm"
			open={true}
			BackdropProps={{ className: '!bg-black !bg-opacity-75' }}
		>
			<DSSpinner className="text-primary-400 w-16 h-16" />
		</Modal>
	);
};

export const FeatureLoader = (props: PropsWithChildren<any>) => {
	return (
		<FeaturesReady timeout={500} fallback={<LoadingSpinner />}>
			{props.children}
		</FeaturesReady>
	);
};
